var constants = require('./constants');

const STATSIG_GOALS = {
    CART: { name: 'ecomm_cart', value: null },
    INTENT_PROCEED: { name: 'ecomm_step_continue_cta', value: 'cart' },
    CHECKOUT_LOGIN: { name: 'account_registration_login', value: null },
    CHECKOUT_DELIVERY: { name: 'ecomm_checkout', value: null },
    CHECKOUT_PAYMENT: { name: 'ecomm_payment', value: null },
    CHECKOUT_CONFIRMATION: { name: 'ecomm_completed', value: null },
    SIGNUP: { name: 'sign_up', value: null }
};

function logStatsigEvent(id) {
    if (!window.Statsig) {
        return;
    }

    if (!STATSIG_GOALS[id]) {
        return;
    }

    const event = STATSIG_GOALS[id];

    window.Statsig.StatsigClient.instance().logEvent(event.name, event.value);
}

function toggleCheckoutOfferBanner() {
    if (window.Statsig) {
        const $body = $('body');
        const $checkoutOfferBanner = $body.find('.js-checkout-offer-banner');
        const statsigInstance = window.Statsig.StatsigClient.instance();
        const experiment = statsigInstance.getExperiment('offer_banner');
        const isOfferBannerEnabled = experiment.get('isOfferBannerEnabled');

        if (isOfferBannerEnabled) {
            $checkoutOfferBanner.removeClass('d-none');
        }
    }
}

module.exports = {
    handleEvent: function (event) {
        const stepGoalMap = {
            cart: 'CART',
            intentToProceed: 'DUALMODE_INTENT_PROCEED',
            signup: 'SIGNUP',
            0: 'CHECKOUT_LOGIN',
            1: 'CHECKOUT_DELIVERY',
            2: 'CHECKOUT_PAYMENT',
            4: 'CHECKOUT_CONFIRMATION',
        };

        const goal = stepGoalMap[event];
        if (goal) {
            logStatsigEvent(goal);
        }
    },
    updateStatsigUser: function (data) {
        // Update the user object
        if (window.Statsig && data && data.statsigUserID) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const { user } = statsigInstance.getContext();
            const newUser = { ...user, userID: data.statsigUserID }
            statsigInstance.updateUserSync(newUser);

            const date = new Date();
            date.setTime(date.getTime() + constants.DAYS_30); // 1 month
            document.cookie = 'statsig_user=' + JSON.stringify(newUser) + '; path=/; ' + cookieDomain + 'expires=' + date.toUTCString() + '; Secure; SameSite=None;';
        }
    },
    handleExperiments: function () {
        toggleCheckoutOfferBanner();
    },
    handleGuestCheckoutForSS: function () {
        if (window.Statsig) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const experiment = statsigInstance.getExperiment('checkout_choice_to_purchase_sub_as_guest_v2');
            const showGuestCheckoutOption = experiment.get('showGuestCheckoutOption');

            if (showGuestCheckoutOption) {
                const date = new Date();
                date.setTime(date.getTime() + constants.DAYS_30); // 1 month
                document.cookie = 'skipLogin=true; path=/; expires=' + date.toUTCString() + ';';

                $('.js-guest-checkout-border').addClass('customer-border-top');
                $('.js-guest-checkout-button').addClass('d-flex');

                if ($('.order-confirmation').data('is-subscription') === true) {
                    $('.order-confirmation .order-confirm-create-account').removeClass('d-flex').addClass('d-none');
                }
            } else {
                document.cookie = 'skipLogin=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            }
        }
    },
    toggleCheckoutDatePicker: function () {
        if (window.Statsig) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const experiment = statsigInstance.getExperiment('checkout_improved_delivery_calendar_v2_corrected_allocation');
            const isModernDatePicker = experiment.get('show_improved_calendar');

            if (isModernDatePicker) {
                $('.shipping-details #shippingDeliveryDate').addClass('d-none').prop('disabled', true);
                $('.shipping-details #shippingDeliveryDateModern').removeClass('d-none');
            } else {
                $('.shipping-details #shippingDeliveryDateModern').prop('disabled', true);
            }
        }
    },
    hideShareBasketButton: function () {
        if (window.Statsig) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const experiment = statsigInstance.getExperiment('cart_remove_share_basket_v2_corrected_allocation');
            const isShareBasketVisible = experiment.get('isShareBasketVisible');
            const $shareBasketButton = $('.checkout-continue .js-share-basket-url-button');
            if (isShareBasketVisible) {
                $shareBasketButton.removeClass('d-none');
            }
        }
    }
};
